"use client";

import type { ElementType, ReactNode } from "react";

import { CcEyebrow, type CcEyebrowTheme } from "@/components/ui/CcEyebrow";

export type CcSanjayaEyebrowProps = {
  children: ReactNode;
  className?: string;
  as?: ElementType;
  /** `on-subtle` on light gray bands; `on-dark` on dark sections. Default `on-subtle`. */
  theme?: CcEyebrowTheme;
  /** Dev-only brand tint preview (`CcSeoValue` toggle). */
  brand?: boolean;
};

/**
 * Sanjaya chip eyebrow for section labels (inspo/sanjaya.framer.ai).
 * Use site-wide for section eyebrows — not on the home hero (`CcHero` / announcement pill).
 */
export function CcSanjayaEyebrow({
  children,
  className,
  as,
  theme = "on-subtle",
  brand = false,
}: CcSanjayaEyebrowProps) {
  return (
    <CcEyebrow
      as={as}
      theme={theme}
      sanjayaGlyphs
      className={[
        "cc-eyebrow--sanjaya",
        brand ? "cc-eyebrow--sanjaya-brand" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </CcEyebrow>
  );
}
